module.exports = __webpack_public_path__ + "img/logo-top.7e8cac02.png";